import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { StepProps } from '../TimsurveyWizard'
import { timsurveyApi } from '../../../services/api'
import { TimsurveyCasistica, TimsurveyNmu } from '../../../types/timsurvey'

export default function StepConferma({ pratica, form, onNext, onBack, salvaBozza }: StepProps) {
  const [errori, setErrori] = useState<string[]>([])
  const [confermando, setConfermando] = useState(false)

  const { data: casistiche } = useQuery({
    queryKey: ['timsurvey-casistiche'],
    queryFn: () => timsurveyApi.catalogo.casistiche().then(r => r.data as TimsurveyCasistica[]),
    staleTime: Infinity,
  })
  const { data: nmu } = useQuery({
    queryKey: ['timsurvey-nmu'],
    queryFn: () => timsurveyApi.catalogo.nmu().then(r => r.data as TimsurveyNmu[]),
    staleTime: Infinity,
  })

  const descrizioneCasistica = (code: string) => casistiche?.find(c => c.code === code)?.descrizione ?? code
  const descrizioneNmu = (code: string) => nmu?.find(n => n.nmu_code === code)?.descrizione ?? code

  const conferma = async () => {
    setErrori([])
    setConfermando(true)
    try {
      await salvaBozza()
      await timsurveyApi.verbale.conferma(pratica.id)
      onNext()
    } catch (err: any) {
      const detail = err.response?.data?.detail
      if (detail && Array.isArray(detail.errori)) {
        setErrori(detail.errori)
      } else {
        setErrori([typeof detail === 'string' ? detail : 'Errore durante la conferma del verbale'])
      }
    } finally {
      setConfermando(false)
    }
  }

  return (
    <div className="card p-4 space-y-3 text-sm">
      <div><span className="text-slate-500">Esito:</span> <strong>{form.esito ?? '—'}</strong></div>
      {form.situazione && <div><span className="text-slate-500">Situazione:</span> <strong>{form.situazione}</strong></div>}

      {form.rilievi.length > 0 && (
        <div>
          <div className="text-slate-500 mb-1">Casistiche fuori standard</div>
          <ul className="list-disc list-inside">
            {form.rilievi.map(r => (
              <li key={r.casistica_code}>{descrizioneCasistica(r.casistica_code)}{r.quantita != null ? ` — ${r.quantita}` : ''}</li>
            ))}
          </ul>
        </div>
      )}

      {form.voci_listino.length > 0 && (
        <div>
          <div className="text-slate-500 mb-1">Voci a listino</div>
          <ul className="list-disc list-inside">
            {form.voci_listino.map(v => (
              <li key={v.nmu_code}>{descrizioneNmu(v.nmu_code)} × {v.quantita}</li>
            ))}
          </ul>
        </div>
      )}

      <div><span className="text-slate-500">Note:</span> {form.note_aggiuntive || '—'}</div>

      {errori.length > 0 && (
        <div className="bg-red-50 border border-red-300 text-red-700 rounded-md p-3">
          {errori.map((e, i) => <div key={i}>{e}</div>)}
        </div>
      )}

      <div className="flex gap-2">
        <button className="btn-secondary" onClick={onBack}>Indietro</button>
        <button className="btn-primary flex-1" disabled={confermando} onClick={conferma}>
          {confermando ? 'Conferma in corso...' : 'Conferma verbale'}
        </button>
      </div>
    </div>
  )
}
